<template>
  <div class="rt-approval-item">
    <div class="rt-approval-icon">
      <rt-icon v-if="iconName" :name="iconName" size="20"></rt-icon>
      <div v-else class="rt-approval-icon-dotted"></div>
    </div>

    <div class="rt-approval-item-middle">
      <p class="title">{{ title }}</p>
      <p class="status">{{ status }}</p>
    </div>
    <p class="time">{{ time }}</p>
  </div>
</template>
<script>
export default {
  name: 'RtApprovalItem',
  props: {
    iconName: String,
    title: String,
    status: String,
    time: String
  }
};
</script>



// WEBPACK FOOTER //
// rtApprovalItem.vue?11dcc072